<div *ngFor="let petTile of petTileList; let i = index;" class="dog-tile-container">
  <app-camper-tile
    [petStatusData]="petTile"
    [petTileList]="petTileList"
    [petImage]="petImage(i)"
  ></app-camper-tile>
</div>
<span
  *ngIf="(petTileList)?.length === 0 && showNoRecordText"
  class="lato"
>No records found.</span>
